module.exports = __webpack_public_path__ + "images/service.672ed9c6.webp";